<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M4.6875 3.90625C2.96161 3.90625 1.5625 5.30536 1.5625 7.03125V17.9688C1.5625 19.6946 2.96161 21.0938 4.6875 21.0938H20.3125C22.0384 21.0938 23.4375 19.6946 23.4375 17.9688V7.03125C23.4375 5.30536 22.0384 3.90625 20.3125 3.90625H4.6875ZM8.98438 7.03125C7.68996 7.03125 6.64062 8.08058 6.64062 9.375C6.64062 10.6694 7.68996 11.7188 8.98438 11.7188C10.2788 11.7188 11.3281 10.6694 11.3281 9.375C11.3281 8.08058 10.2788 7.03125 8.98438 7.03125ZM4.94991 16.0966C5.55302 14.4547 7.13065 13.2812 8.98433 13.2812C10.838 13.2812 12.4156 14.4547 13.0187 16.0966C13.1533 16.4628 12.997 16.8721 12.6527 17.0555C11.5581 17.6386 10.3086 17.9688 8.98433 17.9688C7.66004 17.9688 6.41055 17.6386 5.31595 17.0555C4.97164 16.8721 4.81541 16.4628 4.94991 16.0966ZM15.625 8.59375C15.1935 8.59375 14.8438 8.94353 14.8438 9.375C14.8438 9.80647 15.1935 10.1562 15.625 10.1562H19.5312C19.9627 10.1562 20.3125 9.80647 20.3125 9.375C20.3125 8.94353 19.9627 8.59375 19.5312 8.59375H15.625ZM14.8438 12.5C14.8438 12.0685 15.1935 11.7188 15.625 11.7188H19.5312C19.9627 11.7188 20.3125 12.0685 20.3125 12.5C20.3125 12.9315 19.9627 13.2812 19.5312 13.2812H15.625C15.1935 13.2812 14.8438 12.9315 14.8438 12.5ZM15.625 14.8438C15.1935 14.8438 14.8438 15.1935 14.8438 15.625C14.8438 16.0565 15.1935 16.4062 15.625 16.4062H19.5312C19.9627 16.4062 20.3125 16.0565 20.3125 15.625C20.3125 15.1935 19.9627 14.8438 19.5312 14.8438H15.625Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgMembershipCard',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>